import GlobalStyles from "@mui/material/GlobalStyles";
import { darken } from "@mui/system";
import { css } from "@emotion/react";
import { useTheme } from "@mui/material";

export const AppGlobalStyles = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={
        css`
          ::-webkit-scrollbar {
            width: 0.5em;
            height: 0.5em;
            background-color: #f5f5f5;
          }
          ::-webkit-scrollbar-track {
            background-color: ${theme.palette.grey[300]};
          }
          ::-webkit-scrollbar-thumb {
            border-radius: 1em;
            width: 0.75em;
            background-color: ${theme.palette.primary.main};
            &:hover {
              background-color: ${darken(theme.palette.primary.main, 0.2)};
            }
          }
          ::selection {
            color: ${theme.palette.getContrastText(theme.palette.primary.main)};
            background: ${theme.palette.primary.main};
          }
          body,
          html {
            scrollbar-width: "thin";
            scrollbar-color: ${theme.palette.primary.main +
            " " +
            theme.palette.background.default};
          }
          svg {
            fill: currentColor;
          }
          body,
          #app,
          #root {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: stretch;
          }
          strong,
          strong.MuiTypography-root {
            font-weight: 900;
          }
          .sr-only {
            visibility: hidden;
          }
          :not(.has-helpertext):not(.disable-helpertext-margin):not(.MuiTablePagination-toolbar) {
            /** counter the HelperText that might appear below the textfield, helps the UI not 'jumping' on errror */
            & > .MuiInputBase-root {
              &:not(.Mui-error) {
                margin-bottom: ${theme.spacing(3)};
              }
            }
          }
        `.styles
      }
    />
  );
};
